// extracted by mini-css-extract-plugin
export var btn = "G_m6 s_rD s_rf d_bz d_bP d_bD d_dw";
export var full = "G_t7 d_w d_H";
export var hoverStyle = "G_m9";
export var zoom = "G_nb";